import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';
import languages from './locale';
import { Icon, Button, Upload, Modal, TreeSelect, Checkbox } from "@h3/antd-vue";
let SmartApprove = class SmartApprove extends Vue {
    constructor() {
        super(...arguments);
        this.textValue = '';
        this.defaultFileList = [];
        this.selectValue = '';
        this.focused = false;
    }
    mounted() {
        this.selectValue = undefined;
        this.textValue = this.value;
        this.defaultFileList = this.fileList;
    }
    onValueChange() {
        this.textValue = this.value;
    }
    get t() {
        return languages[this.locale];
    }
    autoHeight(elem) {
        elem.style.height = 'auto';
        elem.scrollTop = 0;
        const { scrollHeight } = elem;
        elem.style.height = `${scrollHeight}px`;
    }
    onTextChange(val) {
        this.focused = true;
        const text = val.target.value;
        this.textValue = text;
        this.autoHeight(val.target);
    }
    onBlur() {
        this.focused = false;
    }
    onCheckboxChange(val) {
        const isChecked = val.target.checked;
        this.$emit('onCheckboxChange', isChecked);
    }
    onSelectChange(val) {
        val = val || '';
        this.selectValue = `${val}`;
        this.textValue = `${val}`;
        this.$emit('onSelectChange', val);
    }
    onSelectFocus() {
        this.$emit('onSelectFocus');
    }
    beforeUpload(file, fileList) {
        // 如果file的大小超出了限制的大小 false
        if (file.size > this.uploadMaxSize) {
            this.$message.error(`${file.name} ${this.t.OverSize}`);
            // this.fileList = [];
            return false;
        }
        // 如果超出了数量也fasle
        if (fileList.length > this.uploadMaxNum) {
            this.$message.error(`${file.name} ${this.t.OverNum}`);
            return false;
        }
        // 如果文件一起超过了大小也false
        // 文件类型判断 不是规定类型返回false
    }
    handleChange(info) {
        console.log('hai');
        console.log(info);
        if (info.file.status !== 'uploading') {
            this.$emit('uploading', info);
        }
        if (info.file.status === 'done') {
            this.$emit('done', info);
            this.$message.success(`${info.file.name} ${this.t.success}`);
        }
        else if (info.file.status === 'error') {
            this.$emit('error', info);
            this.$message.error(`${info.file.name} ${this.t.error}`);
        }
    }
    // @Emit()
    // handlePreview(file:any) {
    // }
    onChange(val) {
        this.$emit('input', val);
    }
};
tslib_1.__decorate([
    Model('input')
], SmartApprove.prototype, "value", void 0);
tslib_1.__decorate([
    Prop()
], SmartApprove.prototype, "prefixCls", void 0);
tslib_1.__decorate([
    Prop()
], SmartApprove.prototype, "prefixStyle", void 0);
tslib_1.__decorate([
    Prop()
], SmartApprove.prototype, "selectStyle", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: 'zh',
    })
], SmartApprove.prototype, "locale", void 0);
tslib_1.__decorate([
    Prop({
        type: Array,
        default: () => new Array(),
    })
], SmartApprove.prototype, "opinions", void 0);
tslib_1.__decorate([
    Prop({
        type: Array,
        default: () => new Array(),
    })
], SmartApprove.prototype, "fileList", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: true,
    })
], SmartApprove.prototype, "supprotSetting", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: true,
    })
], SmartApprove.prototype, "supprotSelect", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: true,
    })
], SmartApprove.prototype, "supprotUpload", void 0);
tslib_1.__decorate([
    Prop({
        type: Object,
        default: () => { },
    })
], SmartApprove.prototype, "headers", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
    })
], SmartApprove.prototype, "action", void 0);
tslib_1.__decorate([
    Prop()
], SmartApprove.prototype, "accept", void 0);
tslib_1.__decorate([
    Prop()
], SmartApprove.prototype, "uploadMaxSize", void 0);
tslib_1.__decorate([
    Prop()
], SmartApprove.prototype, "uploadMaxNum", void 0);
tslib_1.__decorate([
    Prop()
], SmartApprove.prototype, "uploadType", void 0);
tslib_1.__decorate([
    Prop({
        type: Function,
    })
], SmartApprove.prototype, "remove", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false
    })
], SmartApprove.prototype, "withCredentials", void 0);
tslib_1.__decorate([
    Watch('value')
], SmartApprove.prototype, "onValueChange", null);
tslib_1.__decorate([
    Watch('textValue')
], SmartApprove.prototype, "onChange", null);
SmartApprove = tslib_1.__decorate([
    Component({
        name: 'SmartApprove',
        components: {
            AIcon: Icon,
            AButton: Button,
            AUpload: Upload,
            AModal: Modal,
            ATreeSelect: TreeSelect,
            ATreeSelectNode: TreeSelect.TreeNode,
            ACheckbox: Checkbox
        }
    })
], SmartApprove);
export default SmartApprove;
